import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function WhatIsThisSection() {
  return <section className="py-24 bg-[#0a0a0a]" data-id="element-457">
      <div className="container mx-auto px-4" data-id="element-458">
        <div className="text-center mb-16" data-id="element-459">
          <span className="text-[#C9A84C] font-bold tracking-widest text-sm uppercase" data-id="element-460">
            QUÉ ES ESTO
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-461">
          {/* NOT */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-6 text-left md:text-right md:border-r border-white/10 md:pr-12 pb-8 md:pb-0 border-b md:border-b-0 border-white/10" data-id="element-462">
            <h3 className="text-3xl font-['Bebas_Neue'] text-gray-500" data-id="element-463">
              ESTO NO ES
            </h3>
            <ul className="space-y-5" data-id="element-464">
              <li className="flex items-center justify-start md:justify-end gap-4 text-gray-400 text-lg" data-id="element-465">
                <span className="line-through decoration-red-500/50" data-id="element-466">
                  Motivación
                </span>
                <X className="text-red-500 w-5 h-5 shrink-0" data-id="element-467" />
              </li>
              <li className="flex items-center justify-start md:justify-end gap-4 text-gray-400 text-lg" data-id="element-468">
                <span className="line-through decoration-red-500/50" data-id="element-469">
                  Frases bonitas
                </span>
                <X className="text-red-500 w-5 h-5 shrink-0" data-id="element-470" />
              </li>
              <li className="flex items-center justify-start md:justify-end gap-4 text-gray-400 text-lg" data-id="element-471">
                <span className="line-through decoration-red-500/50" data-id="element-472">
                  Teoría vacía
                </span>
                <X className="text-red-500 w-5 h-5 shrink-0" data-id="element-473" />
              </li>
            </ul>
          </motion.div>

          {/* IS */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-6 md:pl-4" data-id="element-474">
            <h3 className="text-3xl font-['Bebas_Neue'] text-[#C9A84C]" data-id="element-475">
              ESTO ES
            </h3>
            <ul className="space-y-5" data-id="element-476">
              {['Entrenamiento mental práctico en vivo', 'Dos mentorías por semana', 'Corrección directa', 'Ejercicios reales', 'Exposición', 'Responsabilidad'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white text-lg font-medium" data-id="element-477">
                  <div className="bg-[#C9A84C]/20 p-1 rounded-full shrink-0" data-id="element-478">
                    <Check className="text-[#C9A84C] w-4 h-4" data-id="element-479" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}